import NoResultImg from '../../../assets/no-result.svg';
import Button from '../../Button';

const SearchNoResultComponent = ({
  result,
  typeSearchText,
  titleRedirect,
  titleBtn,
  handleChangeTab
}) => {
  return (
    <div className="flex flex-col gap-4 items-center">
      <img src={NoResultImg} className="w-[48px] h-[48px]" alt="" />
      <p className="font-[600] text-base md:text-lg text-center">
        Oops! Looks like we don’t have any {typeSearchText} on{' '}
        <span className="text-growth-green-500 font-[900]"> {result} </span> just yet.
      </p>
      <div className="flex flex-col items-center">
        <p className="text-base md:text-lg text-center">
          Try searching for something else, or {titleRedirect}
        </p>
        <Button
          variant="secondary"
          className="w-fit mt-2 text-sm md:text-base"
          onClick={handleChangeTab}
        >
          {titleBtn}
        </Button>
      </div>
    </div>
  );
};

export default SearchNoResultComponent;
